import * as S from "./header.styles";
import { ReactComponent as IconLeftArrow } from "../../../styles/assets/svg/icon-leftArrow.svg";
import { ReactComponent as IconAlarm } from "../../../styles/assets/svg/icon-alarm-brightGray.svg";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";

interface HeaderProps {
  pageTitle?: string;
  background?: string;
  pageHeaderTitle?: string;
  isBack?: boolean;
  showActionButton?: boolean;
  actionButtonText?: string;
  onActionButtonClick?: () => void;
}

export const Header = ({ background, pageTitle }: HeaderProps) => {
  return (
    <S.Header background={background}>
      <S.HeaderTit>{pageTitle}</S.HeaderTit>
      {/* <Link
        to="/alarm"
        style={{ display: pageTitle === "알림" ? "none" : "block" }}
      >
        <IconAlarm width={25} height={25} />
      </Link> */}
    </S.Header>
  );
};

export const CmpHeader = ({ background, pageTitle }: HeaderProps) => {
  return (
    <S.Header background={background}>
      <S.HeaderTit>{pageTitle}</S.HeaderTit>
    </S.Header>
  );
};

export const MoreHeader = ({
  pageTitle,
  pageHeaderTitle,
  showActionButton = false,
  actionButtonText,
  onActionButtonClick,
}: HeaderProps) => {
  const navigate = useNavigate();
  return (
    <S.MoreHeader>
      <S.BackBtnBox onClick={() => navigate(-1)}>
        <IconLeftArrow width={27} height={27} />
        <p>{pageHeaderTitle}</p>
      </S.BackBtnBox>
      <S.MoreHeaderTit>{pageTitle}</S.MoreHeaderTit>
      {showActionButton && (
        <S.MoreHeaderActionButton onClick={onActionButtonClick}>
          {actionButtonText}
        </S.MoreHeaderActionButton>
      )}
    </S.MoreHeader>
  );
};

export const MoreDetailHeader = ({
  pageTitle,
  pageHeaderTitle,
  isBack,
}: HeaderProps) => {
  const navigate = useNavigate();
  return (
    <S.MoreHeader>
      {isBack && (
        <S.BackBtnBox onClick={() => navigate(-1)}>
          <IconLeftArrow width={27} height={27} />
          <p>{pageHeaderTitle}</p>
        </S.BackBtnBox>
      )}
      <S.MoreHeaderTit>{pageTitle}</S.MoreHeaderTit>
    </S.MoreHeader>
  );
};
